import { Col, Container, Row } from "react-bootstrap";
import '../../css/services/services.scss';


export const EnterpriseArchitecture = () => {
  return (
    <div>
      <header className="header">
        <h1>ENTERPRISE ARCHITECTURE AND PROCESS TRANSFORMATION</h1>
      </header>
      <Container>
        <Row>
          <Col className="pt-4">
            <p>
              Create, plan and implement digital business solutions using one platform for collaborative business process analysis and IT solution design. Two best-of-breed products—ARIS and Alfabet—converge to make your enterprise digital-ready. 
              The enterprise business architecture is the primary bridge between ARIS and Alfabet as the graphic below demonstrates. Business capabilities can be captured by both ARIS and Alfabet. Alfabet captures the operating model and ARIS covers design and management of business processes. Synchronized, they ensure that the IT portfolio in Alfabet is seen in the business context.
            </p>

            <h5>Key Benefits</h5>
            <ul>
              <li>Enterprise context for large business transformation initiatives</li>
              <li>Greater agility in providing digital business solutions</li>
              <li>Tighter business-IT collaboration from inception to implementation of business solutions</li>
              <li>Clear insight into the impact of change on business and IT</li>
              <li>Revenue growth through customer focus and market differentiation</li>
              <li>Cost reduction through business and IT standardization</li>
            </ul>
            <h5>Core Functionality</h5>
            <ul>
              <li>Product interoperability for process/IT cross-analytics</li>
              <li>Federated repository for flexible, customer-configurable system of record</li>
              <li>Automated synchronization of ARIS and Alfabet repositories</li>
              <li>Aligned ARIS and Alfabet user interfaces for uniform look and feelon</li>
            </ul>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export const CustomerRelationManagement = () => {
  return (
    <div>
      <header className="header">
        <h1>CUSTOMER RELATION MANAGEMENT</h1>
      </header>
      <Container>
        <Row>
          <Col className="pt-4">
            <p>Nated Systems help companies bridge the ever widening span between the overflow volume of complex data and optimize their ongoing operations and realize a greater digital reach. Our CRM stresses good ongoing relationships with customers. It holds that maintaining these relationships drives growth and profitability. By implementing our CRM solutions will increase your profitability by streamlining processes in your sales, marketing, and service divisions, and letting you focus on building and maintaining the customer relationships that matter. Our CRM solution is a composite platform where everything crucial to developing, improving, and retaining your customer relationships is stored. Without the support of an integrated CRM solution, you may miss growth opportunities and lose revenue because you’re not optimising your operating processes or making the most of your customer relationships or sales leads</p>
            <h3>CRM Features & Capabilities</h3>
            <ul>
              <li>Customer Service: Knowledge bases, Ticketing systems, Live chat, Customer, support portals</li>
              <li>Sales: Creation of quotes, Order processing, Updating contact information, Sending e-mails, Sales forecasting, Evaluating employee performance</li>
              <li>Marketing Automation: Email marketing, Lead management, Lead scoring and qualification, Landing page creation, Web forms, Marketing analytics</li>
            </ul>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export const GovernanceRiskCompliance = () => {
  return (
    <div>
      <header className="header">
        <h1>GOVERNANCE, RISK, AND COMPLIANCE SYSTEM</h1>
      </header>
      <Container>
        <Row>
          <Col className="pt-4">
            <p>Nated System digitizes and aligns an organization’s Governance, Risk and Compliance program with Strategy, to enable the governance, management, and assurance of risk, compliance, and performance across the enterprise.
                Monitor and manage the risks such as fraud, data theft, security threats, privacy breaches, and non-compliance that could negatively impact your enterprise performance objectives. Corporater’s risk and compliance management solutions are among the few that can be fully integrated into a performance management solution.
                Business Management Platform – Enabling An Integrated Approach to GRC
                We offer a Business Management Platform (BMP) that enables organizations to seamlessly connect the areas of governance, performance, risk, and compliance (GPRC). Highly flexible and quick to implement, all Corporater GRC solutions are built on the BMP and can be expanded to cover more expansive performance management needs or unlock synergies between risk and compliance functions.
            </p>
            <h3>
              Key Benefits
            </h3>
            <ul>
              <li>Eliminate Silos: Link the strategic, tactical, and operational layers of your business, eliminate silos, and drive business outcomes.</li>
              <li>Connected Enterprise: Establish a holistic, central point of governance, management, and assurance of the corporation’s performance, risk, and compliance.</li>
              <li>Informed Decision-making: Ensure the information flow empower executives and employees to make sound, timely decisions.</li>
              <li>Integrity and Sustainability: Develop a strong ethical work culture, make environmental and social impact, reduce misconduct, and use metrics to communicate the importance of business integrity.</li>
              <li>Unified Workforce: Have clearly communicated vision, values, and strategy to coordinate across departments and business units to ensure everyone is working towards shared goals.</li>
              <li>Business Impact: Move from data and insights to plans, decisions, and execution within a single platform, to realize business impact.</li>
            </ul>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export const PerformanceManagement = () => {
  return (
    <div>
      <header className="header">
        <h1>PERFORMANCE MANAGEMENT</h1>
      </header>
      <Container>
        <Row>
          <Col className="pt-4">
          <p>
            With Corporater Performance Management software, you can manage, visualize, share, and collaborate at all levels of the organization with dashboards, smart KPIs, strategy maps, and initiatives. With the holistic and individual levels of goals and performance clearly measured, visualized and communicated, you can easily achieve board-level reporting, drive actions towards future development, as well as ensure strategic alignment of operations throughout the organization.
            Enable your organization to manage responsiveness and recovery, communicate the context for change, and share the definitions of success. Corporater provides visibility to performance across the entire organization and helps decision-makers to analyze problems and make business decisions within the business context. Additionally, one can review processes for future development, and assess and communicate risk factors.
            With Corporater, you can introduce lean-transformation programs, or other initiatives for corporate restructuring, continuous improvement or business continuity, all from within the same platform.
          </p>
          <h5>Key Features</h5>
          <ul>
            <li>KPIs, Dashboards, and Analytics: Visualize, benchmark, and analyze critical management information within business context. Automate data collection without technical complexity.</li>
            <li>Corporate Performance Management: Transform your financial planning, forecasting, and budgeting to strategic activities that drive your financial performance forward.</li>
            <li>Employee Performance Management: Align employee goals, training, and incentives with your business strategy and link compensation to targeted metrics.</li>
            <li>Project & Portfolio Management: Manage multiple projects within single view and monitor KPIs of all projects that your organization is undertaking.</li>
          </ul>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export const ProjectManagement   = () => {
  return (
    <div>
      <header className="header">
        <h1>
          PROJECT MANAGEMENT
        </h1>
      </header>
      <Container>
        <Row>
          <Col className="pt-4">
          <p>
            Nated Systems provides a comprehensive solution for managing projects that covers request tracking, project planning, project tracking, project accounting, and portfolio management. Users can collate project requests from multiple sources like emails, forms, and spreadsheets, and then prioritize them based on business KPIs. They can build dynamic project plans that automatically adjust with auto scheduling tools, support for inter-project dependencies, and multiple assigned resources per task.
            Teams can track with milestones, RAG health indicators, critical path analysis, baseline, and EVA methods, as well as automatic email alerts. Project accounting tools provide visibility into budget, receivables, and profitability, with tools for profit and margin tracking, revenue forecasting, and custom KPIs. Portfolio management provides aggregated information across projects on custom dashboards.  
          </p>
          <h5>Key Features</h5>
          <ul>
            <li>Project Request Tracking</li>
            <li>Project Planning</li>
            <li>Project Tracking</li>
            <li>Project Accounting</li>
            <li>Portfolio Management</li>
            <li>Resource Management</li>
            <li>Dynamic Dashboards and Reports</li>
            <li>Team & Client Collaboration</li>
            <li>Time and Expense</li>
          </ul>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export const ServiceManagementSystem  = () => {
  return (
    <div>
      <header className="header">
        <h1>
          SERVICE MANAGEMENT SYSTEM
        </h1>
      </header>
      <Container>
        <Row>
          <Col className="pt-4">
          <p>
            Nated Systems offers a leading customer support ticketing software that serves all small, medium, and enterprise-level business with its 4 different products.
            Help Desk Software - A ticketing software to manage customer support over various channels like email, web portal, VOIP, live chat, API, Facebook, Twitter and more. It comes with unique features like ticket billing, task management, online forums, help desk gamification and more.
            Satellite Help Desk Software - A multi company or multi brand customer support management software. Best fit if you are running multiple websites, brands or products and wanted to offer different branded web portals for each of them having single back end to manage everything at one place.
            Service Desk Software - ITIL/ITSM PinkVerify Certified product that offers all features from help desk and satellite help desk and additionally it offers ITIL compliant features CMDB, Asset Management, Incident Management, Problem Management, Solution or Knowledgeable Management, Change Management and Release Management.
            Live Chat Software - A secure, real-time multi-company live chat messaging platform that improves customer engagement by helping sales teams to convert website visitors into paying customers. Further, It also enhances customer support team productivity by giving them the ability to deliver quick and reliable support.
          </p>
          <h5>Key Features</h5>
          <ul>
            <li>ISO 27001:2013 Certified</li>
            <li>GDPR & EU Data Protection</li>
            <li>PinkVERIFY™ Certified</li>
            <li>Easy to Setup and Get Started</li>
            <li>90% Code Open Easy To Integrate</li>
            <li>Reliable and Quick Support</li>
            <li>All in One Solution</li>
          </ul>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export const DocumentManagementSystem  = () => {
  return (
    <div>
      <header className="header">
        <h1>
          DOCUMENT MANAGEMENT SYSTEM
        </h1>
      </header>
      <Container>
        <Row>
          <Col className="pt-4">
          <p>            
            Nated Systems offers on-premise or in-cloud document management for SMBs to enterprise organizations that are looking to streamline their business and document-intensive processes with workflow automation that includes eSignatures, form submissions, and compliance. Organizations of any size can control and track which users access, change, and share company documents - whether employees are remote or in an office. Leveraging the DMS solutions intelligently identify, categorize and process accounts payable invoices or any other low or high volume paper entering Content Central.
            Our solution is designed to maximize office productivity with automated features to intelligently manage business processes and documents. Our software solutions use optical character recognition (OCR) paired with AI to intelligently identify, categorize, and process scanned documents like accounts payable invoices, tax forms, new hire documents, and more. Automated workflows and integrations with 3rd party business software systems facilitates data lookups, eliminates the need for repetitive data entry, and ensures data integrity across systems, regardless of industry or department.
          </p>
          <h5>Key Features</h5>
          <ul>
            <li>Content Central’s robust workflow engine allows documents to be automatically routed for review, approval, revisions and collaboration.</li>
            <li>Intelligently store and classify your documents so they are easily found when and where you need them - even if you’re on the go.</li>
            <li>Securely send documents for eSignature and forms to users within and without your organization - all while meeting compliance.</li>
            <li>Eliminate redundant data entry and tedious cross-system work by integrating Content Central with your existing 3rd party business solutions.</li>
            <li>Access Controls and System Auditing ensure you meet HIPAA, SOX, FERPA, ISO compliance requirements with ease.</li>
          </ul>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export const EnterpriseResourcePlanning  = () => {
  return (
    <div>
      <header className="header">
        <h1>
          ENTERPRISE RESOURCE PLANNING
        </h1>
      </header>
      <Container>
        <Row>
          <Col className="pt-4">
          <p>
          All-in-one software solution designed to meet the needs of companies, regardless of their size (or budget). The unbeatable, seamless nature of Odoo helps businesses become more efficient by reducing redundant manual processes, which helps companies save countless hours of labor. Every module is interconnected to provide a fully-integrated experience from app to app, and users can automate many processes that would’ve otherwise required manual inputs into multiple applications. Odoo keeps all business functions in one place, allowing teams to collaborate with other departments from one unified platform in the most efficient way possible. Odoo is an innovative, user-friendly, open-source software that offers security features to business technology and software development communities all around the world. The Odoo market offers numerous modules and apps that are tailor-made for any and all business needs.
          </p>
          <h5>Key Features</h5>
          <ul>
            <li>User-friendliness</li>
            <li>Up-to-date and modern</li>
            <li>Integrates with third-party solutions</li>
            <li>Global support</li>
            <li>Less implementation cost</li>
            <li>Readymade apps</li>
            <li>Flexibility</li>
            <li>Highly modular design</li>
          </ul>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export const CustomApplicationDevelopment  = () => {
  return (
    <div>
      <header className="header">
        <h1>
          CUSTOM APPLICATION DEVELOPMENT
        </h1>
      </header>
      <Container>
        <Row>
          <Col className="pt-4">
          <p>
            We offer the full competence designing, creating, deploying and maintaining software for a specific set of users, functions or organizations.
            Nated Systems application development and maintenance service is always in tune with the evolving business requirements and acquires an IT framework that can keep up the pace of our clients. Our deep-rooted domain knowledge and experience enables us to operate in complex application environments and handle client crucial applications efficiently. Our team implements the agile development process to deploy the solution, adhering to the best industry standards and practices. Our team possesses the capability to design and develop technology products that can streamline business processes and grow revenue.
          </p>
          <h5>Key Features</h5>
          <ul>
            <li>Transform legacy applications to leverage emerging technologies</li>
            <li>Conduct in-depth portfolio analysis to discover growth opportunities</li>
            <li>Enable scalable, and efficient processes with cloud migration</li>
            <li>Mobile development services for integrated software systems</li>
            <li>Develop highly customized workflows for multi-channel content distribution</li>
            <li>Enhance digital capabilities to unlock the full potential of IoT, AI, and mobile solutions</li>
            <li>Manages critical software applications development for leading companies, helping customers reduce cost with zero downtime.</li>
          </ul>
          </Col>
        </Row>
      </Container>
    </div>
  );
}